import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "service-dialog"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "abstract" }
const _hoisted_5 = { class: "version" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = { class: "cta" }
const _hoisted_9 = { class: "cta" }

import { ref, onMounted } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTerms',
  setup(__props) {

const localizer = Localizer;
const isLoading = ref(false);
const serviceTerms = ref<any>(null);
const routes = (window as any).App.routes;

onMounted(async () => {
	await getServiceTermsData();
});

async function getServiceTermsData() {
	serviceTerms.value = (await Axios.post(routes.PrivateArea_Terms_GetServiceTermsData)).data;
}

async function setServiceTermsApproval() {
	isLoading.value = true;

	await Axios.post(routes.PrivateArea_Terms_SetServiceTermsApproval);

	await getServiceTermsData();

	isLoading.value = false;
}

async function logout() {
	localStorage.removeItem("token");

	await Axios.post(routes.Account_User_Logout, null);

	window.location.href = routes.Account_User_Login;
}

return (_ctx: any,_cache: any) => {
  return (serviceTerms.value && !serviceTerms.value.isApproved)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ServiceTerms_Title")), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ServiceTerms_Abstract")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(serviceTerms.value.terms.title) + " " + _toDisplayString(serviceTerms.value.terms.version), 1),
          _createElementVNode("div", {
            innerHTML: serviceTerms.value.terms.description,
            class: "desc"
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setServiceTermsApproval())),
                class: "button"
              }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Accept")), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (logout())),
                class: "button",
                "data-type": "transparent"
              }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Refuse")), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})